import { IIntervalService, IRootScopeService } from 'angular';
import { CensoredSystemCollection } from 'app/shared/collections/censored_system_collection.service';
import { ViewStateService } from 'app/shared/view_state.service';
import { IntegrationResource } from '../resources';
import { ImsObjectIncrementalCollection } from './ims_object_incremental_collection.service';
import { Integration } from './integration';
import { SiteStateService } from '../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

/**
 * @ngdoc service
 * @name ims.shared.data.service:integrationCollection
 * @description
 * A collection of ims Integration objects. It handles loading and refreshing data.
 * Note that it is entirely on-demand. Integrations must be loaded on request.
 *
 */
export class IntegrationCollection extends ImsObjectIncrementalCollection {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope: IRootScopeService,
        $interval: IIntervalService,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
        censoredSystemCollection: CensoredSystemCollection,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            IntegrationResource,
            Integration,
            {
                onDemand: false,
            },
        );
        this.defineRelationship('system', null, 'system_id', censoredSystemCollection);
    }
}
